import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { selectToken } from '@drone-js/core';
import { isSameMonth, addMonths, setDate } from 'date-fns';
import { isDifferentMonth } from './util/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var leftSideRadius = ['8', '2', '2', '8'];
var rightSideRadius = ['2', '8', '8', '2'];
var getSpacingToken = function getSpacingToken(theme) {
  return ['2', '4', '8', '12', '16'].reduce(function (acc, cur) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, selectToken(theme.spacing, cur)));
  }, {
    '2': '2px',
    '4': '4px',
    '8': '8px',
    '12': '12px',
    '16': '16px'
  });
};
var getDateBackgroundColor = function getDateBackgroundColor(isSelected, isRangeMiddle) {
  if (isRangeMiddle) return 'product.primary.subtle';
  if (isSelected) return 'product.primary';
  return undefined;
};
var getDateBorderRadius = function getDateBorderRadius(dir, isSelected, isRangeStart, isRangeEnd) {
  if (isRangeStart) return dir === 'rtl' ? rightSideRadius : leftSideRadius;
  if (isRangeEnd && !isRangeStart) return dir === 'rtl' ? leftSideRadius : rightSideRadius;
  if (isSelected) return '8';
  return '8';
};
var getDateTypographyColor = function getDateTypographyColor(isDisabled, isSelected, isRangeMiddle) {
  if (isDisabled) return 'base.disabled';
  if (isRangeMiddle) return 'product.primary';
  if (isSelected) return 'base.inverted';
  return 'base.default';
};
var getDatePriceLabelColor = function getDatePriceLabelColor(colorVariant, isHovered, isFocused, isDisabled) {
  if (isDisabled) return 'base.disabled';
  if (isHovered || isFocused) return 'product.primary';
  if (colorVariant === 'priceLow') return 'feedback.positive';
  if (colorVariant === 'priceHigh') return 'product.price';
  return 'base.subtle';
};
var getDateWrapperBackgroundColor = function getDateWrapperBackgroundColor(isRangeStart, isRangeMiddle, isRangeEnd) {
  if (isRangeMiddle) return 'product.primary.subtle';
  var wrapperBackgroundColor = {
    angle: isRangeStart ? 270 : 90,
    stops: [{
      backgroundColor: 'product.primary.subtle',
      position: '50%'
    }, {
      backgroundColor: 'base.transparent',
      position: '50%'
    }]
  };
  if (isRangeStart && !isRangeEnd) return wrapperBackgroundColor;
  if (isRangeEnd && !isRangeStart) return wrapperBackgroundColor;
  return undefined;
};
var getTodayBackgroundColor = function getTodayBackgroundColor(isSelected, isRangeMiddle) {
  if (isRangeMiddle) return 'product.primary';
  if (isSelected) return 'base.surface';
  return 'product.primary';
};
var getDefaultMonth = function getDefaultMonth(variant, isSingleDate, fromDate, date, dateRange, numberOfMonths, startDate, endDate) {
  var _dateRange$from;
  if (!startDate && endDate) {
    var displayMonth = new Date(endDate);
    displayMonth.setMonth(displayMonth.getMonth() - (numberOfMonths - 1));
    return displayMonth;
  }
  if (variant === 'scrollable') {
    return fromDate;
  }
  return isSingleDate ? date !== null && date !== void 0 ? date : fromDate : (_dateRange$from = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from) !== null && _dateRange$from !== void 0 ? _dateRange$from : fromDate;
};
var getEndDate = function getEndDate(numberOfMonths, startDate, endDate) {
  if (!startDate || !endDate) return endDate ? new Date(endDate) : undefined;
  if (startDate > endDate) {
    var newDate = new Date(startDate);
    newDate.setMonth(newDate.getMonth() + numberOfMonths, 0);
    return newDate;
  }
  return new Date(endDate);
};
var ONE_MONTH = 1;
var TWO_MONTHS = 2;
var getNumberOfMonths = function getNumberOfMonths(variant, scrollableMonthCount, startDate, endDate) {
  if (startDate && endDate && isSameMonth(startDate, endDate)) {
    return ONE_MONTH;
  }
  if (variant === 'double') {
    return TWO_MONTHS;
  }
  if (variant === 'single') {
    return ONE_MONTH;
  }
  return scrollableMonthCount;
};
var getCustomTabbableDate = function getCustomTabbableDate(currentMonth, currentDate, date) {
  var tabbleDate = [];
  var nextMonth = addMonths(currentMonth, 1);
  // Add the provided date if it exists
  if (date) {
    tabbleDate.push(date);
  }
  // Add the current date if it's not in the same month as the provided date
  if (isDifferentMonth(currentDate, date)) {
    tabbleDate.push(currentDate);
  }
  // Add the next month if it's not in the same month as the provided date and the current date
  if (isDifferentMonth(currentDate, nextMonth) && isDifferentMonth(date, nextMonth)) {
    tabbleDate.push(setDate(nextMonth, 1));
  }
  // Add the current month if it's not in the same month as the provided date and the current date
  if (isDifferentMonth(currentDate, currentMonth) && isDifferentMonth(date, currentMonth)) {
    tabbleDate.push(setDate(currentMonth, 1));
  }
  return tabbleDate;
};

export { getCustomTabbableDate, getDateBackgroundColor, getDateBorderRadius, getDatePriceLabelColor, getDateTypographyColor, getDateWrapperBackgroundColor, getDefaultMonth, getEndDate, getNumberOfMonths, getSpacingToken, getTodayBackgroundColor };
//# sourceMappingURL=DatePicker.mappers.js.map
